module.exports = __webpack_public_path__ + "static/assets/6605614e49e41b95f2ad406fb21e4b4a.svg";